var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconCasinoHilo24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_casino_hilo24x24",
    transform: "translate(-3 -1.964)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11789",
    d: "M3.809,13.133a.884.884,0,0,0,.356-.089A24.369,24.369,0,0,0,14.654,8.055a25.892,25.892,0,0,0,2.4-2.138c.089-.089.178-.178.267-.089l.978.713c.267.178.444.089.444-.267l.267-3.92c0-.356-.178-.445-.444-.356L15.1,3.511c-.178,0-.267.178-.178.356a.191.191,0,0,0,.178.178l.889.624c.089.089,0,.178,0,.267a22.89,22.89,0,0,1-2.133,1.871A22.752,22.752,0,0,1,3.72,11.619c-.356.089-.711.445-.622.8-.089.445.267.713.711.713Z",
    transform: "translate(-.009)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11790",
    d: "M19,9.052a1.9,1.9,0,0,1-1.778-.168L17.133,8.8a6.558,6.558,0,0,0-1.244,1.009l-1.156.841c-.978.672-2.044,1.345-3.111,1.933l-1.156.588-3.2,1.261-1.156.336a13.613,13.613,0,0,1-1.778.42.54.54,0,0,0-.356.084H3.711A2.063,2.063,0,0,1,3,15.189v3.026H3a.745.745,0,0,0,.711.672H18.289A.745.745,0,0,0,19,18.215h0V9.052Z",
    transform: "translate(0 -.923)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconCasinoHilo24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_casino_hilo24x24.1ce5810dcb9f0bacc3a0384b74976673.svg";